import { useEffect, useState } from 'react';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import MyButton from '../../../UI/myButton/MyButton';
import InfoTooltip from '../../../UI/InfoTooltip/InfoTooltip';
import useHttp from '../../../../hooks/use-http';
import { urls } from '../api/urls';
import styles from './Zaglavlje.module.css';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../../shared/api/handleErrorMessage';

const Zaglavlje = ({ filterValues, setFilterValues, handlePrikazi }) => {
  const { getData } = useHttp('');
  const [projektiData, setProjektiData] = useState([]);
  const [openToolTip, setOpenToolTip] = useState(false);
  const [savingPrikaz, setSavingPrikaz] = useState(false);
  const { t, i18n } = useTranslation();
  const canShowPrikazKorisniku = localStorage.idFirme === '1';

  const vratiProjekte = async () => {
    const result = await getData({
      url: urls.GET_MASINE_ROBOTE,
      method: 'POST',
      data: {
        idKorProm: +localStorage.idKorisnika,
        metadata: i18n.language,
      },
    });

    if (result?.length > 0) {
      setProjektiData(result);
    } else {
      setProjektiData([]);
    }
  };

  useEffect(() => {
    vratiProjekte();
  }, [i18n.language]);

  const handleClickProjekat = (value) => {
    const prikaz =
      value.prikazPodatakaKlijentu === true ||
      value.prikazPodatakaKlijentu === 1 ||
      value.PrikazPodatakaKlijentu === true ||
      value.PrikazPodatakaKlijentu === 1;

    setFilterValues((curr) => ({
      ...curr,
      idProjekta: value.id,
      nazivProjekta: value.vrednost || '',
      idPp: value.idPp ?? value.idPP ?? null,
      prikazPodatakaKlijentu: prikaz,
    }));
  };

  const handleTogglePrikazKorisniku = async () => {
    if (!filterValues.idProjekta || savingPrikaz) return;

    const novaVrednost = !filterValues.prikazPodatakaKlijentu;
    setSavingPrikaz(true);

    const response = await getData({
      url: urls.UPDATE_PRIKAZ_KLIJENTU,
      method: 'POST',
      data: {
        id: filterValues.idProjekta,
        prikazPodatakaKlijentu: novaVrednost,
        idKorProm: +localStorage.idKorisnika,
      },
    });

    setSavingPrikaz(false);

    if (response?.isAxiosError) {
      toast.error(handleErrorMessage(response));
      return;
    }

    const rezultat = Number(response?.rezultat ?? response?.Rezultat ?? 0);
    if (rezultat <= 0) {
      toast.error(
        response?.opis ||
          response?.Opis ||
          t('projectProgress.errorUpdatingData'),
      );
      return;
    }

    setFilterValues((curr) => ({
      ...curr,
      prikazPodatakaKlijentu: novaVrednost,
    }));

    setProjektiData((curr) =>
      curr.map((item) =>
        item.id === filterValues.idProjekta
          ? { ...item, prikazPodatakaKlijentu: novaVrednost }
          : item,
      ),
    );

    toast.success(t('projectProgress.dataSavedSuccessfully'));
  };

  return (
    <div className={styles.container}>
      <OAutocomplete
        data={projektiData}
        value={filterValues.nazivProjekta}
        handleClick={handleClickProjekat}
        label={t('project')}
        style={{ width: '400px', maxWidth: '100%' }}
      />
      <MyButton
        onClick={handlePrikazi}
        label={t('show')}
        icon="fas fa-search"
      />
      {canShowPrikazKorisniku && (
        <div className={styles.prikazKorisniku}>
          <button
            type="button"
            className={
              filterValues.prikazPodatakaKlijentu
                ? `${styles.switch} ${styles.switchOn}`
                : `${styles.switch} ${styles.switchOff}`
            }
            onClick={handleTogglePrikazKorisniku}
            disabled={!filterValues.idProjekta || savingPrikaz}
            aria-pressed={!!filterValues.prikazPodatakaKlijentu}
          />
          <span className={styles.prikazLabel}>
            {t('projectProgress.showToUser')}
          </span>
          <InfoTooltip
            openToolTip={openToolTip}
            setOpenToolTip={setOpenToolTip}
            text={t('projectProgress.showToUserTooltip')}
          />
        </div>
      )}
    </div>
  );
};

export default Zaglavlje;
